import axios, { CancelTokenSource } from 'axios'
import React, { useEffect, useRef, useState } from 'react'
import { IBookmarksSummary } from '../../../models/Bookmarks'
import BookmarksService from '../../../services/BookmarksService'
import Protected from '../../Protected'
import { BOOKMARKSTYPES } from '../bookmarkstypes'
import useErrorHandler from '../../../hooks/useErrorHandler'
import FormErrorDisplay from '../../common/FormErrorMessages'
import Conditional from '../../common/Conditional'
import Loader from '../../common/Loader'
import '../Bookmarks.css'
import { Button } from 'semantic-ui-react'
import { useHistory } from 'react-router-dom'
const pactBaseUrl = process.env.REACT_APP_PACT_URL

const PayResults = () => {
  const [data, setData] = useState<IBookmarksSummary[]>([])
  const [hasMore, sethasMore] = useState(false)
  const [isLoadingMore, setIsLoadingMore] = useState(false)
  const mountedRef = useRef(false)
  const [isLoading, setIsLoading] = useState(true)
  const [userErrors, handleErrors] = useErrorHandler()
  const size = 10
  const history = useHistory()
  const getPayResults = async (source?: CancelTokenSource) => {
    await BookmarksService.getBookmarks(
      { offset: data.length, size: size },
      { type: BOOKMARKSTYPES.PAYPACT },
      source
    ).then((response) => {
      if (mountedRef.current) {
        const res = response.result
        setData((old) => [...old, ...res.result])
        sethasMore(res.hasMore)
      }
    })
  }
  const loadMorePayResults = async () => {
    setIsLoadingMore(true)
    getPayResults()
      .then(() => {
        setIsLoadingMore(false)
      })
      .catch((error) => {
        setIsLoadingMore(false)
        handleErrors(error)
      })
  }

  useEffect(() => {
    mountedRef.current = true
    const source = axios.CancelToken.source()
    getPayResults(source)
      .then(() => {
        setIsLoading(false)
      })
      .catch((error) => {
        setIsLoading(false)
        handleErrors(error)
      })

    return () => {
      mountedRef.current = false
      if (source) {
        source.cancel('Operation cancelled')
      }
    }
  }, [])

  const deleteBookmark = (id: string) => {
    history.push('/my-account/bookmarks-delete?id=' + id + '&type=results')
  }
  return (
    <Protected>
      <Conditional if={isLoading}>
        <Loader />
      </Conditional>
      <div className="content-wrapper">
        <FormErrorDisplay
          show={userErrors?.length > 0}
          errorsList={userErrors}
        />
        <p></p>
        <h2>Pay results</h2>
        <p></p>
        <article className="main">
          <Conditional if={data && data.length > 0}>
            <div className="table-wrapper">
              <table id="table-payresults">
                <thead>
                  <tr>
                    <th>Date</th>
                    <th className="cell-width">Pay results</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  {data.length > 0 &&
                    data.map((item, index) => (
                      <tr key={index} className="cell-color">
                        <td>{item.createdOn}</td>
                        <td>
                          {' '}
                          <a href={item.sourceUrl} target="blank">
                            {item.title}
                          </a>
                        </td>
                        <td className="float-right">
                          <Button
                            className="ui is-secondary button"
                            onClick={() => deleteBookmark(item.id)}
                          >
                            Delete
                          </Button>

                          {/* <DeleteConfirmPopupButton
                            id={item.id}
                            onError={handlePopupButtonErrors}
                            retUrl="/my-account/bookmarked-results"
                          ></DeleteConfirmPopupButton> */}
                        </td>
                      </tr>
                    ))}
                </tbody>
              </table>
            </div>
          </Conditional>
          <Conditional if={hasMore}>
            <button
              onClick={loadMorePayResults}
              className="button is-primary"
              type="button"
              disabled={isLoadingMore}
            >
              Load more
            </button>
          </Conditional>
          <Conditional if={!hasMore && !isLoading && data.length > 0}>
            <p className="d-flex justify-content-center">
              <b>No more bookmarked pay results</b>
            </p>
          </Conditional>
          <Conditional
            if={data.length <= 0 && !isLoading && userErrors?.length <= 0}
          >
            <p className="d-flex">
              You have no bookmarked pay results from the&nbsp;
              <a href={pactBaseUrl + '/FindYourAward'}>Pay Calculator</a>.
            </p>
            <p></p>
          </Conditional>
        </article>
      </div>
    </Protected>
  )
}

export default PayResults
